import { Link } from 'react-router-dom';

export default function MembershipPromo() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20lounge%20interior%20with%20warm%20golden%20ambient%20lighting%2C%20comfortable%20velvet%20seating%2C%20abstract%20art%20on%20walls%2C%20luxurious%20yet%20inviting%20atmosphere%2C%20soft%20cream%20and%20warm%20beige%20tones%2C%20premium%20cinema%20lounge%20aesthetic&width=1800&height=800&seq=membership-bg&orientation=landscape"
        alt="麻豆在线会员"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/50 to-foreground-950/30"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-lg">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
            加入麻豆在线会员
          </h2>
          <p className="text-background-50/80 mb-8 leading-relaxed">
            畅享无广告观影、4K超清画质、独家原创内容、优先观影权等多重专属权益。会员分为普通、黄金、钻石三个等级，满足不同需求。
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/category/huiyuan-zhuanxiang"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              了解会员权益
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}